import { useEffect, useState } from 'react';

/**
 * Delay a rapidly-changing value until it settles.
 *
 * Filtering moved server-side, so every keystroke in a filter box is now an
 * HTTP request. Without this, typing "registration" fires twelve of them, the
 * responses race, and the table can settle on the result of a prefix rather
 * than what is actually in the box.
 *
 * 400ms: long enough to cover normal typing, short enough that it does not feel
 * like the screen is lagging behind.
 */
const useDebouncedValue = (value, delay = 400) => {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return settled;
};

export default useDebouncedValue;
